document.addEventListener('click', function(e) {
  var header = e.target.closest('.footer-navigation-header');
  if (header && window.innerWidth <= 991) {
    var nav = header.closest('.footer-navigation');
    if (nav) {
      var isOpen = nav.classList.contains('is-open');
      document.querySelectorAll('.footer-navigation').forEach(function(item) {
        item.classList.remove('is-open');
      });
      if (!isOpen) {
        nav.classList.add('is-open');
      }
    }
  }

  var locBtn = e.target.closest('.localization-btn');
  if (locBtn) {
    var wrapper = locBtn.closest('.localization-dropdown-wrapper');
    var popover = wrapper ? wrapper.querySelector('.localization-popover') : null;
    if (popover) {
      var isHidden = popover.hasAttribute('hidden');
      document.querySelectorAll('.localization-popover').forEach(function(p) { p.setAttribute('hidden', ''); });
      document.querySelectorAll('.localization-btn').forEach(function(b) { b.setAttribute('aria-expanded', 'false'); });
      if (isHidden) {
        popover.removeAttribute('hidden');
        locBtn.setAttribute('aria-expanded', 'true');
      }
    }
  } else if (!e.target.closest('.localization-dropdown-wrapper')) {
    document.querySelectorAll('.localization-popover').forEach(function(p) { p.setAttribute('hidden', ''); });
    document.querySelectorAll('.localization-btn').forEach(function(b) { b.setAttribute('aria-expanded', 'false'); });
  }
});

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape' || e.keyCode === 27) {
    document.querySelectorAll('.localization-popover').forEach(function(p) { p.setAttribute('hidden', ''); });
    document.querySelectorAll('.localization-btn').forEach(function(b) { b.setAttribute('aria-expanded', 'false'); });
  }
});
